import { render, staticRenderFns } from "./OrderTimeline.vue?vue&type=template&id=adfb9be4&scoped=true"
import script from "./OrderTimeline.vue?vue&type=script&lang=js"
export * from "./OrderTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfb9be4",
  null
  
)

export default component.exports